interface McpKeyConversion {
  key: string;
  value: string;
}

export const mcpKeysConversionMap: Record<string, McpKeyConversion> = {
  host: {
    key: 'Is Mcp Host',
    value: 'Is MCP Host',
  },
  client: {
    key: 'Is Mcp Client',
    value: 'Is MCP Client',
  },
  connection: {
    key: 'Is Mcp Connection',
    value: 'Is MCP Connection',
  },
};
